import * as R from 'ramda';
export const deriveProp = R.curry((prop, getDerivedValue, value) => R.assoc(prop, getDerivedValue(value), value));
export default deriveProp;
